import Box from "@mui/material/Box";
import { FormProvider, useForm } from "react-hook-form";
import RhfTextBox from "../../../libs/rhf-mui/RhfTextBox";
import { AppBar, Button, Container, createTheme, Grid, ThemeProvider, Toolbar, } from "@mui/material";
import { linear_content_style, linear_item, linear_v, } from "../../../libs/linear-layout/LinearLayout";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { useGV } from "../../GV";
import AuthHelper from "../../heplers/AuthHelper";

type Props = {};

const FrmAdminLogin = (props: Props) => {
  const theme = createTheme({ palette: { primary: { main: "#795548" } } });

  let account_number_sign: string = "帳號";
  let password_sign: string = "密碼";

  const rhf = useForm<any>();
  const ctx = useAppContext();

  const GV = useGV();

  function render_header() {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" style={{ backgroundColor: "#795548" }}>
          <Toolbar>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }

  async function OnSubmit(rhf_data: any) {
    const id = rhf_data.emp_id;
    const pw = rhf_data.emp_pw;

    AuthHelper.EmpLogin(GV, ctx, id, pw);
  }


  function OnInvalid(errors: any) {
    alert(errors);
  }

  return (
    <ThemeProvider theme={theme}>
      <Box style={linear_content_style}>
        <Grid {...linear_v}>
          <Grid {...linear_item} flex={1}>
            <Box
              style={linear_content_style}
              sx={{
                backgroundColor: { xs: "#ffffff", sm: "#eff0f4" },
              }}
            >
              <FormProvider {...rhf}>
                <Grid {...linear_item}>{render_header()}</Grid>
                <Container maxWidth="lg" sx={{ mx: "auto" }}>
                  <form
                    onSubmit={rhf.handleSubmit(
                      (data: any) => {
                        OnSubmit(data);
                      },
                      (errors: any) => {
                        OnInvalid(errors);
                      }
                    )}
                  >
                    <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ mt: 2 }}                    >
                      <Grid item sx={{ mb: 3 }}>
                        <RhfTextBox name="emp_id" label={account_number_sign} variant="filled" />
                      </Grid>
                      <Grid item sx={{ mb: 3 }}>
                        <RhfTextBox type="password" name="emp_pw" label={password_sign} variant="filled" />
                      </Grid>
                      <Grid item>
                        <Button type="submit" variant="contained">
                          登入
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Container>
              </FormProvider>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  );
};

export default FrmAdminLogin;
